import { useMemo, type ReactNode } from 'react';
import { I18nextProvider, useTranslation } from 'react-i18next';

import { MOCK_LANGUAGE, mockI18n } from '@/lib/mockEnglish';

/**
 * Всё внутри — по-английски при любом языке интерфейса (mock test, решение владельца 20.10.2026).
 * Почему экраном, а не ключами, — `lib/mockEnglish.ts`.
 */
export function MockEnglish({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  const en = useMemo(() => mockI18n(i18n), [i18n]);
  return (
    <I18nextProvider i18n={en}>
      {/* lang — для чтения с экрана и переводчика браузера: текст внутри английский. */}
      <div lang={MOCK_LANGUAGE}>{children}</div>
    </I18nextProvider>
  );
}
